import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { saveLanguagePreference, SupportedLanguage } from './languageUtils';

// Import translations
import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationES from './locales/es.json';

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  es: {
    translation: translationES
  }
};

// Configuration for i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    
    // Common namespace used around the full app
    defaultNS: 'translation',
    
    // language detection options
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    
    react: {
      useSuspense: true
    }
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng: string) => {
  // Ensure lng is a supported language
  if (lng === 'en' || lng === 'es' || lng === 'fr') {
    saveLanguagePreference(lng as SupportedLanguage);
    
    // Update HTML lang attribute
    document.documentElement.setAttribute('lang', lng);
  }
});

export default i18n; 